import { chip } from '../theme.js';
import { cn } from '../../lib/cn.js';

/**
 * 一行筛选 chip。询盘页和客户页共用。
 *
 * 做成组件而不是各页 map 一遍,是因为「当前选中长什么样」这件事
 * 只能有一种答案 —— 两页一个是蓝底白字一个是深色底白字的话,
 * 工厂会以为这是两个不同的控件。
 */
export function Segmented<T extends string>({
  value,
  options,
  onChange,
  testIdPrefix,
  className,
}: {
  value: T;
  options: ReadonlyArray<{ value: T; label: string; disabled?: boolean; count?: number }>;
  onChange: (v: T) => void;
  testIdPrefix: string;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn('flex flex-wrap gap-2', className)}
      role="tablist"
      data-testid={`${testIdPrefix}-filters`}
    >
      {options.map((o) => {
        const on = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={on}
            disabled={o.disabled}
            onClick={() => onChange(o.value)}
            className={cn(chip.base, on ? chip.on : chip.off)}
            data-testid={`${testIdPrefix}-filter-${o.value}`}
          >
            {o.label}
            {/* 计数只在有东西的时候画 —— 一排 (0) 是噪音 */}
            {o.count ? <span className="ml-1 tabular-nums opacity-70">{o.count}</span> : null}
          </button>
        );
      })}
    </div>
  );
}
